import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import { Subject } from 'rxjs/Subject';
import { AuthService } from '../../store/services/auth.service';
import { ActionService } from '../../store/services/action.service';
import { FirestoreService } from '../../shared/firestore/firestore.service';
import * as moment from 'moment';
moment.locale('ja');


@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.sass']
})
export class ActionsComponent implements OnInit {
  allActions$: Observable<any[]>;
  actions$: Observable<any[]>;
  project$: Observable<any>;
  searchTerm$: Observable<string>;
  searchMonth$: Observable<string>;
  searchDay$: Observable<string>;
  searching: boolean;

  constructor(
    private firestore: FirestoreService,
    private auth: AuthService,
    private action: ActionService,
  ) {}

  async ngOnInit() {
    const profile$ = this.auth.getUserProfile();
    this.project$ = profile$.map(profile =>
      this.firestore.findUser(profile.userId))
      .switchMap(x => x.data$)
      .map(u => this.firestore.findProject(u.mainProjectId))
      .switchMap(x => x.data$);
    this.allActions$ = profile$.map(profile =>
      this.firestore.findUser(profile.userId))
      .switchMap(x => x.actions$);

    this.searchTerm$ = this.action.searchTerm$;
    this.searchMonth$ = this.action.searchMonth$;
    this.searchDay$ = this.action.searchDay$;

    this.actions$ = Observable.combineLatest(
      this.allActions$,
      this.searchTerm$,
      this.searchMonth$,
      this.searchDay$,
      (actions, term, month, day) =>
        actions
          .filter(action => !term || action.name === term)
          .filter(action => !month || moment(action.timestamp).format('YM') === moment(month).format('YM'))
          .filter(action => !day || moment(action.timestamp).format('YMD') === moment(day).format('YMD'))
      ,
    );
    this.clear();
  }

  search(name: string) {
    this.action.search(name);
    this.searching = true;
  }
  searchByMonth(timestamp: string) {
    this.action.searchByMonth(timestamp);
    this.searching = true;
  }
  searchByDay(timestamp: string) {
    this.action.searchByDay(timestamp);
    this.searching = true;
  }

  clear() {
    this.search('');
    this.searchByMonth('');
    this.searchByDay('');
    this.searching = false;
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/actions/actions.component.ts